<div class="wrapper">
    <!-- Header -->
    <app-header></app-header>

    <!-- Page Content  -->
    <div class="body-wrapper">
     
       <!-- Sidebar  -->
       <app-sidebar></app-sidebar>

       <!-- Main Content  -->
       <div class="main-panel" id="main-content-div">
         <!-- [closable]="false" -->
            <p-dialog header="Automatic Logout" [(visible)]="showAutoLogout" [modal]="true" [style]="{width: '50vw'}"  [baseZIndex]="10000"
            [draggable]="false" [resizable]="false" (onHide)="reset()">
               <div class="p-dialog-content pb-3 pt-3" style="border: 0;">
                  <p style="line-height: 2.0">We noticed that your sesssion has been idle for some time. </p>
                  <p style="line-height: 2.0" class="mb-2">You'll be logged out in {{ getCountdownSeconds ?? 0 }} second(s) unless we detect some activity!</p>
               </div>
                  <!-- <ng-template pTemplate="footer"> -->                  
                  <p-button icon="pi pi-check" (click)="reset()" label="Stay Logged In" class="p-button-text mr-2"></p-button>
                  <p-button icon="pi pi-times" (click)="logout()" label="Logout" class="p-button-text"></p-button>
              <!-- </ng-template> -->
           </p-dialog>
          <div class="content-wrapper">
            <router-outlet></router-outlet>
          </div>
          
       </div>
    </div>
 </div>